const mutations = {
  setAllEmployeeTags(state, tags) {
    state.allEmployeeTags = tags || [];
  },
};

export default mutations;
